import ReturnArrow from '../../src/legacy/ReturnArrow.tsx';
export default ReturnArrow;
